import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Img = styled.img`
  border: 2px solid white;
  border-radius: 40px;
  width: 40px;
  min-width: 40px;
  height: 40px;
  flex-shrink: 0;
  box-shadow: ${props => props.theme.dashboardBoxShadow};
`;

export default function RoundedAvatar({ name, profilePictureUrl }) {
  return (
    <Img
      src={profilePictureUrl || window.getLivewireAssetPath('avatar-fallback.png')}
      alt={name}
    />
  );
}

RoundedAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  profilePictureUrl: PropTypes.string,
};

RoundedAvatar.defaultProps = {
  profilePictureUrl: null,
};
